var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 36C59.2843 36 66 29.2843 66 21C66 12.7157 59.2843 6 51 6C42.7157 6 36 12.7157 36 21C36 23.3995 36.5634 25.6675 37.5652 27.6787C37.8314 28.2132 37.92 28.8241 37.7657 29.4009L36.8723 32.74C36.4844 34.1895 37.8105 35.5156 39.26 35.1277L42.5991 34.2343C43.1759 34.08 43.7868 34.1686 44.3213 34.4348C46.3325 35.4366 48.6005 36 51 36Z",
    fill: "#295F98",
    stroke: "#295F98",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1128 21.9485L26.0598 25.4373C27.8169 28.5857 27.1115 32.716 24.3441 35.4834C24.3441 35.4834 24.3441 35.4834 24.3441 35.4834C24.344 35.4835 20.9874 38.8403 27.0735 44.9265C33.1589 51.0118 36.5158 47.6567 36.5166 47.6559C36.5166 47.6559 36.5166 47.6559 36.5166 47.6558C39.2841 44.8884 43.4143 44.1831 46.5627 45.9402L50.0515 47.8872C54.8057 50.5405 55.3672 57.2077 51.1883 61.3866C48.6773 63.8976 45.6012 65.8514 42.2007 65.9803C36.4763 66.1974 26.7548 64.7486 17.0031 54.9969C7.25138 45.2452 5.80264 35.5237 6.01965 29.7993C6.14857 26.3988 8.10241 23.3227 10.6134 20.8117C14.7923 16.6328 21.4595 17.1943 24.1128 21.9485Z",
    fill: "#295F98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.1f84a2ab3525c740e5ed540e62788770.svg";
export { ForwardRef as ReactComponent };